var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('div',{staticClass:"preloader"},[_c('div',{attrs:{"id":"status"}},[_c('b-spinner',{staticStyle:{"width":"3rem","height":"3rem"},attrs:{"label":"Large Spinner","variant":"primary"}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }